import { ColumnDef, createColumnHelper } from '@tanstack/react-table'

import { OrdersCardsDataTypes } from 'types/orders-details-westfieldcorp'

export const useTablesOrdersCards = ({
  dataTable,
}: {
  dataTable: OrdersCardsDataTypes[]
}) => {
  const columnHelper = createColumnHelper<OrdersCardsDataTypes>()
  const columns = [
    columnHelper.accessor('cardNumber', {
      header: () => 'Trader #',
      cell: (info) => {
        const productId = info.getValue()

        return (
          <p className="flex flex-col">
            <span>{productId}</span>
          </p>
        )
      },
    }),
    columnHelper.accessor('cardNumber', {
      header: () => 'Card #',
      cell: (info) => {
        const card = info.getValue()

        return (
          <p className="flex flex-col">
            <span>{card}</span>
          </p>
        )
      },
    }),
  ] as ColumnDef<OrdersCardsDataTypes>[]

  return {
    dataTable,
    columns,
  }
}
